"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var hslBuilder_1 = __importDefault(require("@haptik/helpers/build/esm/hslBuilder"));
var hslDisplay_1 = __importDefault(require("@haptik/helpers/build/esm/hslDisplay"));
var tabs_1 = __importDefault(require("relements/build/esm/ui/tabs"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var RHSLoader_1 = __importDefault(require("@src/components/BotResponses/RHSLoader"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
var styled_components_1 = __importDefault(require("styled-components"));
var OCDropdown_1 = __importDefault(require("@src/components/OCDropdown"));
var store_1 = __importDefault(require("@src/store"));
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var const_1 = require("@src/const");
require("./BotBreakMessage.scss");
// Wrapper Component for Tabs
var wrapperStyles = function (props) {
    var theme = props.theme;
    return {
        marginBottom: theme.space.md + theme.space.xs,
        border: "1px solid " + theme.colors.grey.neon,
        borderRadius: theme.radii.lg,
        width: 'fit-content',
        padding: "0 " + theme.space.md + "px 0 " + theme.space.md + "px",
    };
};
var TabWrapper = styled_components_1["default"](box_1["default"])(wrapperStyles);
var HSLWrapperStyles = function (props) {
    var theme = props.theme;
    return {
        padding: theme.space.md,
        marginTop: 6,
        marginBottom: 16,
        borderRadius: theme.radii.sm,
        border: "1px solid " + theme.colors.grey.haptik,
        flexDirection: 'column',
        maxWidth: 390,
    };
};
var GptBotBreakInfoStyles = function (props) {
    var theme = props.theme;
    return {
        padding: '6px',
        fontSize: theme.fontSizes[1] + "px",
        fontWeight: theme.fontWeights.normal,
        marginBottom: '13px',
        borderRadius: theme.radii.sm,
        border: "1px solid " + theme.colors.grey.haptik,
        flexDirection: 'column',
    };
};
var HSLWrapper = styled_components_1["default"](box_1["default"])(HSLWrapperStyles);
var GptBotBreakInfo = styled_components_1["default"](box_1["default"])(GptBotBreakInfoStyles);
var BotBreakMessages = function (_a) {
    var gptValue = _a.gptValue, value = _a.value, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.hybridLanguages, hybridLanguages = _c === void 0 ? [] : _c, handleHybridLanguageScriptChange = _a.handleHybridLanguageScriptChange, currentHybridLanguage = _a.currentHybridLanguage, languageSource = _a.languageSource, handleOCDropdownChange = _a.handleOCDropdownChange, currentChannel = _a.currentChannel, isTranslateLoading = _a.isTranslateLoading, currentChannelName = _a.currentChannelName, webSDKSaved = _a.webSDKSaved, _d = _a.isTranslated, isTranslated = _d === void 0 ? false : _d, _e = _a.isGptTranslated, isGptTranslated = _e === void 0 ? false : _e, _f = _a.isGptBotBreakEnable, isGptBotBreakEnable = _f === void 0 ? false : _f, onGptBasedCheckChange = _a.onGptBasedCheckChange, _g = _a.gptBotbreakPromptExtension, gptBotbreakPromptExtension = _g === void 0 ? '' : _g, onGptBotbreakPromptExtensionChange = _a.onGptBotbreakPromptExtensionChange;
    var botBreakMessage = value && value.length ? value : [''];
    var gptBotBreakMessage = gptValue && gptValue.length ? gptValue : [''];
    var isContextualBotBreakEnable = store_1["default"].getFeatureFlag(MogamboConstants_1.FEATURE_FLAG_DATA.FLAGS.ENABLE_CONTEXTUAL_BOT_BREAK);
    var hslProps = {
        value: botBreakMessage,
        onChange: onChange,
        withVariants: true,
        withReplies: true,
        isTranslated: isTranslated,
        channelsEnabled: ['whatsapp'],
        currentChannelName: currentChannelName,
    };
    var gptHslProps = {
        value: gptBotBreakMessage,
        withVariants: true,
        withReplies: true,
        isGptTranslated: isGptTranslated,
        channelsEnabled: ['whatsapp'],
        currentChannelName: currentChannelName,
    };
    var handleHybridTabChange = react_1["default"].useCallback(function (script) {
        handleHybridLanguageScriptChange(script);
    }, [handleHybridLanguageScriptChange]);
    var renderHybridLanguageTabs = react_1["default"].useMemo(function () {
        var tabData = [];
        if (hybridLanguages && hybridLanguages.length > 0) {
            hybridLanguages.forEach(function (item) {
                tabData.push(react_1["default"].createElement(tabs_1["default"].Item, { value: item.script, onClick: function () { return handleHybridTabChange(item.script); } }, item.native_name));
            });
        }
        return tabData;
    }, [handleHybridTabChange, hybridLanguages]);
    var renderHSL = function () {
        if (!disabled) {
            return (react_1["default"].createElement(hslBuilder_1["default"], __assign({ isRephraseEnabled: store_1["default"].getFeatureFlag(MogamboConstants_1.FEATURE_FLAG_DATA.FLAGS.ENABLE_REPHRASE_RESPONSES) && languageSource === 'en', baseUrl: const_1.BASE_URL }, hslProps)));
        }
        return react_1["default"].createElement(hslDisplay_1["default"], __assign({}, hslProps));
    };
    var renderGptHSL = function () {
        if (!disabled) {
            return (react_1["default"].createElement(hslBuilder_1["default"], __assign({ isRephraseEnabled: store_1["default"].getFeatureFlag(MogamboConstants_1.FEATURE_FLAG_DATA.FLAGS.ENABLE_REPHRASE_RESPONSES) && languageSource === 'en', baseUrl: const_1.BASE_URL, onChange: function (val) {
                    onChange(val, true);
                } }, gptHslProps)));
        }
        return react_1["default"].createElement(hslDisplay_1["default"], __assign({}, gptHslProps));
    };
    return (react_1["default"].createElement("div", { className: "botbreak-message", style: hybridLanguages ? { paddingTop: 0 } : {} },
        hybridLanguages && (react_1["default"].createElement(TabWrapper, null,
            react_1["default"].createElement(tabs_1["default"], { themed: true, value: currentHybridLanguage }, renderHybridLanguageTabs))),
        react_1["default"].createElement(OCDropdown_1["default"], { selectedChannel: parseInt(currentChannel, 10), onOCDropDownChange: handleOCDropdownChange, showChannelChangeError: webSDKSaved, style: {
                maxWidth: 390,
            } }),
        react_1["default"].createElement(box_1["default"], { style: {
                paddingLeft: 12,
                flexDirection: 'column',
                maxWidth: 390,
            } },
            react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, isGptBotBreakEnable ? 'General Bot Break Message' : 'Variants'),
            react_1["default"].createElement(HSLWrapper, null, !isTranslateLoading ? (renderHSL()) : (react_1["default"].createElement(RHSLoader_1["default"], { relativeAlign: true, text: "Loading " + currentChannelName + " translations" })))),
        isContextualBotBreakEnable && (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(box_1["default"], null,
                react_1["default"].createElement(checkbox_1["default"].Item, { disabled: disabled, value: isGptBotBreakEnable, label: "Contextual Bot Break Message", onChange: onGptBasedCheckChange })),
            react_1["default"].createElement(box_1["default"], { backgroundColor: "yellow.pastel", borderRadius: "sm", width: "fit-content", margin: "6px 12px 12px 7px", padding: "12px", alignItems: "center" },
                react_1["default"].createElement(text_1["default"], { variant: "body.md" },
                    "When faced with challenging user queries, \"Contextual Bot Break Message\" enhances the Bot's ability to understand the conversation's context and then deliver intelligently adapted responses that surpass standard break messages.",
                    react_1["default"].createElement("br", null),
                    react_1["default"].createElement("br", null),
                    "It's also important to note that in case where Bot Breaks occur due to Code Node failures, missing connections, or Bot Response issues, the platform will display the \"General Bot Break Message\" only.")),
            isGptBotBreakEnable && (react_1["default"].createElement(box_1["default"], { style: {
                    paddingLeft: 12,
                    flexDirection: 'column',
                    maxWidth: 390,
                } },
                react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Follow-up for \"Contextual Bot Break Message\""),
                react_1["default"].createElement(HSLWrapper, null,
                    react_1["default"].createElement(GptBotBreakInfo, null, "The first message sent will be the \"Contextual Bot Break Message\". The below message is optional. If configured, it will be sent as an immediate follow-up to the \"Contextual Bot Break Message\"."),
                    !isTranslateLoading ? (renderGptHSL()) : (react_1["default"].createElement(RHSLoader_1["default"], { relativeAlign: true, text: "Loading " + currentChannelName + " translations" }))),
                react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Custom Instructions for Contextual Bot Break (Max 150 Words)"),
                react_1["default"].createElement(text_2["default"], { themed: true, multiline: true, placeholder: "Enter the custom instructions for Contextual Bot Break", error: gptBotbreakPromptExtension.trim().split(/\s+/).length > 150, onChange: onGptBotbreakPromptExtensionChange, value: gptBotbreakPromptExtension.trim(), style: {
                        overflowY: 'auto',
                        marginTop: 4,
                    } })))))));
};
exports["default"] = BotBreakMessages;
